import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectChatInterfaceState } from 'models/twilio';
import useChatVisibility from 'components/twilio/hooks/useChatVisibility';

const disabledPaths = [
  '/booth',
  '/preview',
];

const showMobileChatButton = (path) => !disabledPaths.some((disabledPath) => path.startsWith(disabledPath));

const useMobileButton = () => {
  const { pathname } = useLocation();
  const twilioVisible = useChatVisibility();
  const twilioWindowActive = useSelector(selectChatInterfaceState);

  return useMemo(() => (!twilioWindowActive
    && showMobileChatButton(pathname)
    && twilioVisible
  ), [pathname, twilioWindowActive, twilioVisible]);
};

export default useMobileButton;
